import { State } from '@/views/changelog-settings/changelog-settings.types';

const state: State = {
  settingsLoading: false,
  systemAutoAccept: false,
  userAutoAccept: false,
};

export default state;
